import { Pipe, PipeTransform } from '@angular/core';
import { decodeBase64ToText } from '../../utility';
import { AuthService } from '../../auth/auth.service';

@Pipe({
  name: 'canViewActionItem',
})
export class CanViewActionItemPipe implements PipeTransform {
  private userData: any;

  constructor(private auth: AuthService) {
    const cookieData = this.auth.getCookie();
    if (cookieData) {
      this.userData = JSON.parse(decodeBase64ToText(cookieData));
    } else {
      this.userData = null; 
    }
  }

  transform(accountable: any): boolean {
    if (accountable === this.userData?.data?.user_id) {
      return true;
    }
    return false;
  }
}
